import * as styles from 'styles/pages/Styleguide.css'
import Insights from 'components/features/insights/Insights/Insights'
import { REGULAR_INSIGHTS } from 'fixtures/sg-insights'
import Insight from 'components/features/insights/Insight/Insight'

const SGInsights = () => (
  <section className={ styles.sgSection }>
    <Insights
      placement='dashboard_general'
      insights={ REGULAR_INSIGHTS }
      onInsightShown={ null }
      isMobile
    />
    {
      REGULAR_INSIGHTS.map((insight) => (
        <div key={ insight.id } className={ styles.sgSection }>
          <Insight insight={ insight } />
        </div>
      ))
    }
  </section>
)

export default SGInsights
